import { initializeApp } from "firebase/app";
import { GoogleAuthProvider, getAuth, signInWithPopup, signOut } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

import { allowedDomain, firebaseConfig, firestoreDatabase } from "./firebase-config";

export const firebaseApp = initializeApp(firebaseConfig);

export const auth = getAuth(firebaseApp);

export const firestore = getFirestore(firebaseApp, firestoreDatabase);

/**
 * `hd` restreint le sélecteur de compte Google au domaine Gojob. C'est du confort,
 * pas de la sécurité : la vraie vérification est côté serveur et dans les règles.
 */
export async function signIn(): Promise<void> {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ hd: allowedDomain, prompt: "select_account" });
  await signInWithPopup(auth, provider);
}

export const signOutOfRadio = () => signOut(auth);
